import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { BookingService } from "../../service/booking.service";
import { Router } from "@angular/router";
import { WatabilightService } from "../../service/watabilight.service";
import { HttpClient } from "@angular/common/http";
import { IQuote, IWatabiLightBooking } from "libraries/interfaces/watabilight/IWatabiLightBooking.interface";
import { FormGroup } from "@angular/forms";
import { Yii } from "../../../libraries/interfaces/Yii";
import { MatDialog } from "@angular/material/dialog";
import { MailDialogComponent } from "./component/mail-dialog/mail-dialog.component";
import { IWatabiLightSection, IWatabiLightSectionDetails, IWenji } from "libraries/interfaces/IWenji";
import { WatabiPostDataFormattingService } from "../../service/watabiPostDataFormatting.service";
import { forkJoin } from "rxjs";
import { INotification, NotificationType } from "libraries/interfaces/INotification";
import { ReferenceComponent } from "./component/reference/reference.component";
import { PriceComponent } from "./component/price/price.component";
import { TravellerComponent } from "./component/traveller/traveller.component";
import { AgencyComponent } from "./component/agency/agency.component";
import { CustomerComponent } from "./component/customer/customer.component";
import { ModalLinkComponent } from "./component/modal-link/modal-link.component";
import { Title } from "@angular/platform-browser";
import * as moment from "moment";
import { LabelService } from "libraries/service/label/label.service";
import { DateMomentPipe } from "libraries/date/dateMoment.pipe";

declare const wenji: IWenji;

class Wording {
    public readonly titleQuote: string = Yii.t('wui-shared-js', 'Marge agence');
    public readonly margin: string = Yii.t('wui-shared-js', 'Commission choisie');
    public readonly step: string = Yii.t('wui-shared-js', 'Étapes');
    public readonly nextStep: string = Yii.t('wui-shared-js', 'Enregistrer');
    public readonly stepPreview: string = Yii.t('wui-shared-js', 'Prévisualiser');
    public readonly stepGenerate: string = Yii.t('wui-shared-js', 'Envoyer');
    public readonly loading: string = Yii.t('wui-shared-js', 'Chargement');
    public readonly previ: string = Yii.t('wui-shared-js', 'Prévisualisation');
    public readonly close: string = Yii.t('wui-shared-js', 'Fermer');
    public readonly errorMailCustomer: string = Yii.t('wui-shared-js', 'Email client non valide');
    public readonly errorMailAgency: string = Yii.t('wui-shared-js', 'Email Agence non valide');
    public readonly errorConfig: string = Yii.t('wui-shared-js', 'Erreur, aucune configuration de restitution trouvée, restitution impossible');
    public readonly notIsLatestOutputForAgency: string = Yii.t('wui-shared-js', "Cette proposition n'est plus valide car une nouvelle proposition a été générée.");
    public readonly isExpired: string = Yii.t('wui-shared-js', "Cette proposition a expiré le %date%.");
    public readonly goToLastOutput: string = Yii.t('wui-shared-js', "Afficher la dernière proposition");
}

enum EWatabiLightBookingParts {
    reference = "reference",
    price = "price",
    traveller = "traveller",
    customer = "customer",
    agency = "agency"
}

@Component({
    selector: 'booking-watabi-light',
    templateUrl: './booking.component.html',
    styleUrls: [
        './booking.component.scss'
    ]
})
export class BookingComponent implements OnInit {

    @ViewChild("ref")
    public refComponent: ReferenceComponent;
    @ViewChild("price")
    public priceComponent: PriceComponent;
    @ViewChild("traveller")
    public travellerComponent: TravellerComponent;
    @ViewChild("customer")
    public customerComponent: CustomerComponent;
    @ViewChild("agency")
    public agencyComponent: AgencyComponent;

    public bookingId: string = null;
    public wui_url: string = `${sessionStorage.getItem("$wui_url")}`;

    public redirect_url = "watabilight/init/xx";
    public readonly parts: typeof EWatabiLightBookingParts = EWatabiLightBookingParts;
    public form: FormGroup;

    public wording: Wording = new Wording();

    public formValue: any;
    public booking: IWatabiLightBooking;
    public restitutionConfig: any;

    public isLoading: boolean = false;
    public disableStep: boolean = true;
    public isNotReady: boolean = true;

    public titleResume: string;
    public descriptionResume: string;
    public titleStep: string;
    public descriptionStep: string;

    public sectionConfig: IWatabiLightSection;

    public errorNotification: INotification = {active: false, message: "", type: NotificationType.Error};

    public isLatestOutputForAgency: boolean;
    public latestOutputLink: string;
    public isExpired: boolean = false;

    constructor(
        private readonly bookingService: BookingService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly dialog: MatDialog,
        private readonly formattingService: WatabiPostDataFormattingService,
        private readonly http: HttpClient,
        private readonly router: Router,
        private readonly title: Title,
        private readonly watabilightService: WatabilightService,
        private readonly labelService: LabelService,
        private readonly dateMomentPipe: DateMomentPipe
    ) {
    }

    public ngOnInit(): void {
        this.bookingId = this.bookingService.getBookingId();
        if (!this.bookingId) {
            this.router.navigateByUrl(this.redirect_url);
            return;
        }
        if (wenji.watabilight.section) {
            this.sectionConfig = JSON.parse(wenji.watabilight.section);
        }
        if (this.sectionConfig?.margeResume) {
            const section: IWatabiLightSectionDetails = this.sectionConfig?.margeResume;
            this.titleResume = section?.title ? section?.title : this.wording?.titleQuote;
            this.descriptionResume = section?.description ? section?.description : "";
        }
        if (this.sectionConfig?.step) {
            const section: IWatabiLightSectionDetails = this.sectionConfig?.step;
            this.titleStep = section?.title ? section?.title : this.wording?.step;
            this.descriptionStep = section?.description ? section?.description : "";
        }
        this.initFormGroup();
        this.getBooking();
    }

    public getBooking(): void {

        forkJoin([
            this.watabilightService.getBooking(this.bookingService.getBookingId(), this.bookingService.getBookingIdVersion()),
            this.watabilightService.getConfig(this.bookingService.getBookingIdVersion()),
        ])
            .subscribe({
                next: ([booking, restitutionConfig]: [IWatabiLightBooking, object]): void => {

                    this.computeWarnings(booking);
                    this.booking = booking;
                    // @ts-ignore
                    const pageTitle: string = `${Yii.t('wui-shared-js', 'Modification')} - ${this.booking.introduction?.title} - ${wenji.watabilight.name}`;
                    this.title.setTitle(pageTitle);
                    if (!restitutionConfig) {
                        this.handleError(this.wording.errorConfig);
                    } else {
                        this.restitutionConfig = restitutionConfig;
                        if (this.restitutionConfig?.config?.watabilight) {
                            this.restitutionConfig.config = this.restitutionConfig.config.watabilight;
                        }
                    }


                },
                error: (error: Error): void => {
                    this.router.navigateByUrl(this.redirect_url);
                },
            });
    }

    public initFormGroup(): void {
        this.form = new FormGroup({
            [EWatabiLightBookingParts.reference]: new FormGroup({}),
            [EWatabiLightBookingParts.price]: new FormGroup({}),
            [EWatabiLightBookingParts.traveller]: new FormGroup({}),
            [EWatabiLightBookingParts.customer]: new FormGroup({}),
            [EWatabiLightBookingParts.agency]: new FormGroup({}),
        });
    }

    public editBooking(part: number): void {
        if (part === 5) {
            this.isNotReady = true;
        } else {
            this.updateComponent(part);
            this.formValue = this.form.value;
            this.form.markAllAsTouched();
            this.disableStep = !this.checkEmail();
        }
    }

    public checkEmail(): boolean {
        const filter: RegExp = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
        if (!this.form.valid) {
            return false;
        }
        if (!filter.test(this.formValue?.customer?.mail)) {
            return false;
        }
        if (!filter.test(this.formValue?.agency?.mail)) {
            return false;
        }
        return true;
    }

    public updateComponent(x: number): void {
        this.changeDetectorRef.detectChanges();
        if (x === 3) {
            this.refComponent?.update();
        } else if (x === 2) {
            this.priceComponent?.update();
        }
    }

    public valid(): void {
        if (this.checkEmail()) {
            this.isLoading = true;
            const data = this.formattingService.formateData(this.formValue, this.booking);
            this.watabilightService.postData(data)
                .subscribe({
                    next: (value: any): void => {
                        this.handleError();
                        this.editConfig();
                    },
                    error: (error: any): void => {
                        this.handleError(error);
                    }
                });
        }
    }

    public preview(): void {
        this.isLoading = true;
        this.watabilightService.preview(this.restitutionConfig).subscribe({
            next: (value: any) => {
                this.watabilightService.switchXToken();
                this.dialog.open(ModalLinkComponent, {
                    width: '80%',
                    height: '80%',
                    data: {url: value, type: "page"}
                });
                this.handleError();
            },
            error: (error: any) => {
                this.watabilightService.switchXToken();
                this.handleError(error);
            }
        });
    }

    public generate(): void {
        this.isLoading = true;
        this.watabilightService.check().subscribe({
            next: () => {
                this.versionning();
            },
            error: (error: any) => {
                this.handleError(error);
            }
        });
    }

    private versionning(): void {
        this.watabilightService.apiPublicVersioning().subscribe({
            next: (value: any) => {
                this.handleError("", false);
                this.bookingService.setBookingIdVersion(value.idVersion);
                this.create(value);
            },
            error: (error: any) => {
                this.handleError(error);
                this.watabilightService.switchXToken();
            }
        });
    }

    private create(booking: any): void {
        this.watabilightService.generate(this.restitutionConfig).subscribe({
            next: (value: any) => {
                this.watabilightService.switchXToken();
                const dialog = this.dialog.open(MailDialogComponent, {
                    width: '500px',
                    height: '500px',
                    data: {url: value, template: this.restitutionConfig.config.email, value: booking}
                });
                dialog.afterClosed().subscribe(result => {
                    if (result) {
                        this.handleError(result);
                    }
                });
                this.handleError();
            },
            error: (error: any) => {
                this.handleError(error);
                this.watabilightService.switchXToken();
            }
        });
    }

    private handleError(message: string = null, stopLoader: boolean = true): void {
        if (stopLoader) {
            this.isLoading = false;
        }
        if (message) {
            this.errorNotification = {
                active: true,
                message
            };
        } else {
            this.errorNotification = {
                active: false,
                message: "",
            };
        }
    }

    private editConfig(): void {
        if (this.restitutionConfig) {
            if (this.formValue.agency.logo) {
                this.restitutionConfig.config.global.logoAgency = this.formValue.agency.logo;
            }
            this.restitutionConfig.agencyRestitution = this.bookingService.getWabatiHash();
            this.isNotReady = false;
        }
    }

    private computeWarnings(booking: IWatabiLightBooking): void{
        this.isLatestOutputForAgency = booking.outputValidityForAgency?.isLatestOutputForAgency;
        if (!this.isLatestOutputForAgency) {
            this.latestOutputLink = booking.outputValidityForAgency.latestOutputForAgency.url;
            this.errorNotification = {
                active: true,
                message: this.wording.notIsLatestOutputForAgency,
                type: NotificationType.Warning,
            };
        }
        if (this.isLatestOutputForAgency) {
            let expDate: Date;
            if (booking.quotes.length === 1) {
                expDate = new Date(booking.quotes[0].validity.end);
            } else {
                booking.quotes.forEach((quote: IQuote): void => {
                    if (!expDate) {
                        expDate = new Date(quote.validity.end);
                    } else {
                        const newDate: Date = new Date(quote.validity.end);
                        if (newDate > expDate) {
                            expDate = newDate;
                        }
                    }
                });
            }

            const toDay: Date = new Date();

            this.isExpired = expDate < toDay;

            if (this.isExpired) {
                this.errorNotification = {
                    active: true,
                    message: this.labelService.completeLabel(
                        this.wording.isExpired,
                        {date: this.dateMomentPipe.transform(expDate, JSON.parse(wenji.ui.dateFormat).momentShort)}
                    ),
                    type: NotificationType.Warning,
                };
            }
        }
    }
}
